import {drawNeonCity} from './NeonCity';
import {drawBackgroundCharacters} from './BackgroundCharacters';
import {hasWorkshopBackground} from './workshopAccess';
import {drawPixelBackground} from './PixelBackgrounds';
import {hasPremiumAccess} from './premiumAccess';
export const BACKGROUNDS=[
 {id:'none',name:'ללא רקע',colors:['#202b3e','#344258']},
 {id:'blur',name:'טשטוש עדין',colors:['#687586','#b4b3bd']},
 {id:'mint',name:'סטודיו מנטה',colors:['#244b49','#a4daca']},
 {id:'lavender',name:'חלום סגול',colors:['#34274e','#b49bcf']},
 {id:'sunset',name:'שעת שקיעה',colors:['#553853','#ecaa83']},
 {id:'twinkling-space',name:'חלל מנצנץ',achievement:true,image:'/backgrounds/twinkling-space.png',colors:['#080d26','#30204f']},
 {id:'art-studio',name:'סטודיו לאמנות',achievement:true,image:'/backgrounds/art-studio.png',colors:['#947a62','#e7d9c8']},
 {id:'office',name:'משרד באור טבעי',premium:true,image:'/backgrounds/office.png',colors:['#826346','#e1d3bd']},
 {id:'realistic-garden',name:'גן פיות וגנומים',premium:true,image:'/backgrounds/garden.png',colors:['#37533b','#bacb91']},
 {id:'garden',name:'גן קסום · פיקסלים',premium:true,colors:['#37533b','#bacb91']},
 {id:'pixel-shelter',name:'מקלט אטומי · פיקסלים',premium:true,colors:['#263d40','#bbaa65']},
 {id:'aurora',name:'זוהר צפוני',premium:true,colors:['#091c34','#55e1ae']},
 {id:'city',name:'עיר ניאון',premium:true,colors:['#100e35','#ec51cc']},
 {id:'galaxy',name:'בין כוכבים',premium:true,colors:['#141132','#8263d8']},
 {id:'lounge',name:'טרקלין זהב',premium:true,colors:['#211d2c','#c8a061']},
 {id:'pixel-adventure',name:'הרפתקת פיקסלים',premium:true,colors:['#398759','#ead299']},
 {id:'pixel-pirate',name:'שודדי ים · פיקסלים',premium:true,colors:['#237994','#f0b884']},
 {id:'sakura',name:'פריחת הדובדבן',premium:true,colors:['#503e69','#f7bdde']},
];
export const availableBackground=id=>{const item=BACKGROUNDS.find(b=>b.id===id);return !item?'none':item.achievement&&!hasWorkshopBackground(id)?'mint':item.premium&&!hasPremiumAccess()?'mint':item.id;};
const photos=new Map();
function drawPhoto(ctx,item,w,h,time){
 let img=photos.get(item.id);
 if(!img){img=new Image();img.src=`${process.env.PUBLIC_URL||''}${item.image}`;photos.set(item.id,img);}
 if(!img.complete||!img.naturalWidth)return;
 const scale=Math.max(w/img.naturalWidth,h/img.naturalHeight);
 ctx.drawImage(img,(w-img.naturalWidth*scale)/2,(h-img.naturalHeight*scale)/2,img.naturalWidth*scale,img.naturalHeight*scale);
 drawBackgroundCharacters(ctx,item.id,w,h,time);
 if(item.id==='twinkling-space'){
  ctx.save();
  try{
   const t=(Number.isFinite(time)?time:0)/1000;
   for(let i=0;i<24;i++){
    const x=((i*137.51+57)%997)/997*w,y=((i*71.13+29)%991)/991*h;
    const strength=.15+.45*(.5+.5*Math.sin(t*(.6+i%3*.13)+i*1.7));
    const radius=Math.max(2,Math.min(w,h)*.007)*(i%3===0?1.5:1);
    const halo=ctx.createRadialGradient(x,y,0,x,y,radius);
    halo.addColorStop(0,`rgba(237,245,255,${strength})`);
    halo.addColorStop(.18,`rgba(182,211,255,${strength*.5})`);
    halo.addColorStop(1,'rgba(128,173,255,0)');
    ctx.fillStyle=halo;ctx.fillRect(x-radius,y-radius,radius*2,radius*2);
   }
  }finally{ctx.restore();}
 }
}
export function drawBackground(ctx,id,w,h,time=0){
 if(id==='garden'||id==='pixel-adventure'||id==='pixel-pirate'||id==='pixel-shelter'){drawPixelBackground(ctx,id,w,h,time);return;}
 const item=BACKGROUNDS.find(b=>b.id===id)||BACKGROUNDS[0];
 const gradient=ctx.createLinearGradient(0,0,w,h);item.colors.forEach((color,i)=>gradient.addColorStop(i,color));ctx.fillStyle=gradient;ctx.fillRect(0,0,w,h);
 if(item.image){drawPhoto(ctx,item,w,h,time);return;}
 const t=time/1000;
 if(id==='galaxy'){for(let i=0;i<100;i++){const x=((i*137.51)%997)/997*w,y=((i*71.13)%991)/991*h;ctx.fillStyle=`rgba(235,228,255,${.3+.5*(.5+.5*Math.sin(t*.4+i))})`;ctx.beginPath();ctx.arc(x,y,i%7===0?2:1,0,Math.PI*2);ctx.fill();}}
 if(id==='aurora'){for(let i=0;i<6;i++){ctx.strokeStyle=['#5bf4b540','#63a7ff45','#d19bff40'][i%3];ctx.lineWidth=h*.08;ctx.beginPath();ctx.moveTo(-30,h*(.15+i*.1));ctx.bezierCurveTo(w*.35,h*(.5+Math.sin(t*.2)*.08),w*.6,-h*.2,w+30,h*(.25+i*.08));ctx.stroke();}}
 if(id==='city')drawNeonCity(ctx,w,h,time);
 if(id==='lounge'){ctx.strokeStyle='#e3c48b65';ctx.lineWidth=2;for(let i=0;i<5;i++){ctx.beginPath();ctx.ellipse(w/2,h*.75,w*(.22+i*.08),h*(.7+i*.1),0,Math.PI,2*Math.PI);ctx.stroke();}ctx.fillStyle='#ecd5a035';ctx.fillRect(0,h*.85,w,h*.15);}
 if(id==='sakura'){for(let i=0;i<28;i++){const x=((i*113.7+t*9)%640)/640*w,y=((i*79.3+t*14)%480)/480*h;ctx.save();ctx.translate(x,y);ctx.rotate(i+t*.2);ctx.fillStyle=i%2?'#ffe2f0cc':'#f4abcbd0';ctx.beginPath();ctx.ellipse(0,0,7,3,0,0,Math.PI*2);ctx.fill();ctx.restore();}}
}
